var AddressType;
(function (AddressType) {
    AddressType["DELIVERY"] = "delivery";
    AddressType["INVOICE"] = "invoice";
    AddressType["PUDO"] = "pudo";
})(AddressType || (AddressType = {}));
var AddressEnum;
(function (AddressEnum) {
    AddressEnum["firstName"] = "firstName";
    AddressEnum["lastName"] = "lastName";
    AddressEnum["additionalInformation"] = "additionalInformation";
    AddressEnum["street"] = "street";
    AddressEnum["postalCode"] = "postalCode";
    AddressEnum["city"] = "city";
    AddressEnum["countryShortName"] = "countryShortName";
    AddressEnum["phoneNumber"] = "phoneNumber";
    AddressEnum["birthDate"] = "birthDate";
    AddressEnum["sameAsShipping"] = "sameAsShipping";
    AddressEnum["taxId"] = "taxId";
    AddressEnum["addNewDeliveryAddress"] = "add";
})(AddressEnum || (AddressEnum = {}));
var ErrorEvent;
(function (ErrorEvent) {
    ErrorEvent["FORM_FAILED"] = "FORM_FAILED";
})(ErrorEvent || (ErrorEvent = {}));
var UserAction;
(function (UserAction) {
    UserAction["SAVE_ADDRESS"] = "SAVE_ADDRESS";
    UserAction["UPDATE_ADDRESS"] = "UPDATE_ADDRESS";
    UserAction["CANCEL"] = "CANCEL";
})(UserAction || (UserAction = {}));
var FormFieldTypes;
(function (FormFieldTypes) {
    FormFieldTypes["TEXT"] = "text";
    FormFieldTypes["SELECT"] = "select";
    FormFieldTypes["CHECKBOX"] = "checkbox";
    FormFieldTypes["TELEPHONE"] = "telephone";
    FormFieldTypes["DATE"] = "date";
    FormFieldTypes["INFO_BOX"] = "infoBox";
    FormFieldTypes["ANCHOR"] = "anchor";
})(FormFieldTypes || (FormFieldTypes = {}));

export { AddressEnum, AddressType, ErrorEvent, FormFieldTypes, UserAction };
//# sourceMappingURL=address-form-types.js.map
